import { MenuButton } from '@reach/menu-button';
import classnames from 'classnames';
import React from 'react';

import { IconChevron } from '@wetransfer/transfer/spaces-bundle/components/Icons/Icons';

import './NavigationSubmenuButton.scss';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isExpanded?: boolean;
};

export const NavigationSubmenuButton: React.FC<Props> = ({ ...props }) => {
  const { title, isExpanded, onClick } = props;

  return (
    <MenuButton
      className="NavigationSubmenuButton"
      aria-label="Features submenu"
      onClick={onClick}
    >
      <span className="NavigationSubmenuButton__label" title={title}>
        {title}
      </span>
      <IconChevron
        className={classnames('NavigationSubmenuButton__arrow', {
          'NavigationSubmenuButton__arrow--default': !isExpanded,
          'NavigationSubmenuButton__arrow--open': isExpanded,
        })}
      />
    </MenuButton>
  );
};
